import { useState } from 'react';
import { Glyphicon } from 'react-bootstrap';
import { IToDoItem, ToDoSectionVariant } from './models';
import ToDoItem from './to-do-item';

const iconMap: Record<ToDoSectionVariant, string> = {
    urgent: 'exclamation-sign',
    compliance: 'list-alt'
};

interface IProps {
    title: string,
    subtitle?: string,
    variant: ToDoSectionVariant,
    items: IToDoItem[],
    hideEmptyItems: boolean,
    emptyMessage: string
}

const ToDoSection = ({ title, subtitle, variant, items, hideEmptyItems, emptyMessage }: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const activeCount = items.filter(x => x.count > 0).length;
    const visibleItems = hideEmptyItems ? items.filter(x => x.count > 0) : items;

    return (
        <div className={`ac-card ac-${variant}`}>
            <div className='ac-card-header' onClick={() => setExpanded(!expanded)}>
                <span className='ac-card-icon'><Glyphicon glyph={iconMap[variant]} /></span>
                <h4>{title}</h4>
                <span className='ac-pill'>{activeCount}</span>
                {subtitle && <span className='ac-card-subtitle'>{subtitle}</span>}
                <span className='ac-card-spacer'></span>
                <button type='button' className='ac-card-toggle' aria-expanded={expanded} aria-label={(expanded ? 'Collapse ' : 'Expand ') + title} onClick={e => { e.stopPropagation(); setExpanded(!expanded); }}>
                    <Glyphicon glyph={expanded ? 'chevron-up' : 'chevron-down'} />
                </button>
            </div>

            {expanded ?
                <div className='ac-card-body'>
                    {visibleItems.map(item =>
                        <ToDoItem key={item.key} item={item} />
                    )}

                    {visibleItems.length == 0 && (
                        <div className='ac-empty'>{emptyMessage}</div>
                    )}
                </div>
                :
                <div className='ac-card-collapsed'></div>
            }
        </div>
    );
}

export default ToDoSection;
